import React from "react";
import Navbar from "../components/Navbar";
import { Box, Container, Stack } from "@mui/material";
import Form from "../components/Form";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CheckboxList from "../components/CheckboxList";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Footer from "../components/Footer";

function Home() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column", // Stack children vertically
        minHeight: "100vh", // Ensure the Box takes full viewport height
      }}
    >
      <Navbar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Align children vertically
          justifyContent: "center", // Center items horizontally
          alignItems: "center", // Center items vertically
          flexGrow: 1, // Allow this Box to grow and fill available space
        }}
      >
        <Container sx={{ pt: 1, pb: 2, minWidth: 320 }}>
          <Card sx={{ mt: "60px" }}>
            <CardContent>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <h1>Inserisci i dati della tua Trattativa</h1>
              </Box>
              <Form />
            </CardContent>
          </Card>
        </Container>
        <Container sx={{ pt: 1, pb: 2, minWidth: 320 }}>
          <Card>
            <CardContent>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <h1>Seleziona i Documenti</h1>
              </Box>
              <CheckboxList />
            </CardContent>
          </Card>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default Home;
